import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { DashboardService } from '../../../services/dashboard.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-interview',
  templateUrl: './interview.component.html',
  providers: [DashboardService]
})
export class InterviewComponent implements OnInit {

  date: string;
  authUser: any = {};
  interviewList: Array<any> = [];
  currentWeekLastDate: Date;
  currentWeekFirstDate: Date;
  nextWeekLastDate: Date;
  nextWeekFirstDate: Date;
  lastWeekLastDate: Date;
  lastWeekFirstDate: Date;
  currentDate: Date = new Date();

  private constants = Constants;

  constructor(
    private datePipe: DatePipe,
    private cookieManagerService: CookieManagerService,
    private DashboardService: DashboardService,
  ) { }

  ngOnInit() {
    let $this = this;
    let date = new Date();
    // get login user details
    this.getAuthUser();
    // check the permission to view the widget
    this.checkAdminUserPermission();
    // get current week first date and last date
    var firstDateOfCurrentWeek = date.getDate() - date.getDay(); // First day is the day of the month - the day of the week
    this.currentWeekFirstDate = new Date(date.setDate(firstDateOfCurrentWeek));
    this.currentWeekLastDate = new Date(date.setDate(firstDateOfCurrentWeek + 6));
    // get nextweek first date and last date
    this.nextWeekFirstDate = new Date(date.setDate(this.currentWeekFirstDate.getDate() + 7));
    this.nextWeekLastDate = new Date(date.setDate(this.currentWeekLastDate.getDate() + 7));
    // get last week first date and last date
    this.lastWeekFirstDate = new Date(date.setDate(this.currentWeekFirstDate.getDate() - 7));
    this.lastWeekLastDate = new Date(date.setDate(this.currentWeekLastDate.getDate() - 7));
}

  /**
   * kaushalya 
   * 2017-7-11
   * get interview details according to the date range
   * @param event 
   * @param startDate 
   * @param endDate 
   */
  showProjectReleaseInDateRange(event, fromtDate, toDate) {
    var startDate = this.datePipe.transform(fromtDate, this.constants.dateFormat);
    var endDate = this.datePipe.transform(toDate, this.constants.dateFormat);
    // get the id from the event
    var idAttr = event.target.id;
    //remove and add new class
    $('.intervie-button').removeClass('active');
    $('#' + idAttr).addClass('active');
    this.getInterview(startDate, endDate)
  }

  getInterview(startDate, endDate) {
    this.DashboardService.getInterviewDetailsByDateRange({ startDate, endDate }).subscribe(
      res => {
        this.interviewList = Object.keys(res.data.interview).map((key) => { return res.data.interview[key] });
      }
    );
  }

/**
 * kaushalya
 * 2017-07-11
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * kaushalya
   * 2017-07-11
   * check user is adminUser or supervisor to give view permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#interviews').hide();
    }else{

    // get interview stails accord current dateing to the 
    this.getInterview(this.datePipe.transform(this.currentDate, this.constants.dateFormat), this.datePipe.transform(this.currentDate, this.constants.dateFormat))
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/interview/interview.component.ts